// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qBa9","name":"Header_name__1UWkk","birthday":"Header_birthday__1rfkv","skeleton":"Header_skeleton__3cosT"};